export default class PromiseBatcher<T = any> {
    private promise: Promise<T>;
    private resolver: Function = null;
    private count = 0;
    
    constructor(fun: () => T, finallyCallback: Function) {
        this.invoke(fun)
            .finally(() => finallyCallback());
    }
    
    public getPromise(): Promise<T>{
        return this.promise;
    }
    
    private invoke(fun: () => T): Promise<T> {
        this.promise = new Promise<T>((resolve) => {
            this.resolver = resolve;
            return fun();
        }).finally(() => {
            this.promise = null;
        });
        
        return this.promise;
    }
    
    public add(promise: Promise<any>): void {
        this.count++;
        
        promise.finally(() => {
            this.count--;
            
            if (this.count <= 0)
                this.resolver();
        });
    }
}